import React from 'react';

//CORE COMPONENTS
import { IntegratorRoot } from '../../../components-core/packages/components-core/dist/integrator-root/index';
import { 
    ThemeProvider, 
    styled
} from '../../../components-core/packages/components-core/dist/theme-provider/index';

//LAYOUT
import { 
    Container, 
    ContainerWrap, 
    ContainerPadding,
    ContainerHorizontalAlignment,
    ContainerGutter,
} from '../../../components-core/packages/components-core/dist/container/index';
import {  Layout } from '../../../components-core/packages/components-core/dist/layout/index';
import { Breakpoints } from '../../../components-core/packages/components-core/dist/helpers';
import { BreakpointWrapper } from '../../../components-core/packages/components-core/dist/breakpoint-wrapper/index';
import { AspectRatioContainer, AspectRatio } from '../../../components-core/packages/components-core/dist/aspect-ratio-container/index';

//STYLE
import { Text, TextAppearance, } from '../../../components-core/packages/components-core/dist/text';
import { LazyImage, Image } from '../../../components-core/packages/components-core/dist/image/index';
import { Accordion } from '../../../components-core/packages/components-core/dist/accordion/index';

//CUSTOM COMPONENTS
import CustomAccordion from '../custom-accordion/CustomAccordion';



const SmallImage = styled.img`
    width: 80px;
    height: 60px;

    background-color: #c2cacf;
    flex: 0 0 auto;

    object-fit: cover;
    object-position: 50% 50%;
`;

const SelectedLine = styled.div`
    width: 80px;
    height: 2px;
    background-color: #000000;
    display: ${props => props.isSelected ? 'block' : 'none'}
`;

const ClickableDiv = styled.div`
    cursor: pointer;
`;


class AccordionContent extends React.Component {

    constructor() {
        super();
        this.state = {
            selectedIndex: 0,
            selectedImageIndex: 0,
        }
    }

    //AspectRatioContainer ile tekrardan yap
    renderSmallImages(isMobile) {
        const dataList = sampleList(this.props);
        return dataList.map((data, index) => {
            if (!data.title) {
                return undefined;
            }

            return (
                <ClickableDiv onClick={() => this.setState({ selectedImageIndex: index })}>
                    <Container 
                        wrap={ContainerWrap.always} 
                        gutter={ContainerGutter.static100} 
                        padding={{ 
                            left: index === 0 ? isMobile ? ContainerPadding.dynamic0120 : ContainerPadding.dynamic0120 : ContainerPadding.static100,
                            right: index === dataList.length - 1 && isMobile && (ContainerPadding.dynamic0120)
                        }}
                    >
                        <SmallImage src={data.image}/>
                        <SelectedLine isSelected={this.state.selectedImageIndex === index} />
                    </Container>
                </ClickableDiv>
            )
        })
    }

    renderSmallImagesForDesktop() {
        const horizontalAlign = {
            [Breakpoints.default]: ContainerHorizontalAlignment.flexStart,
            [Breakpoints.b960]: ContainerHorizontalAlignment.flexEnd
        }

        return (
            <Container horizontalAlign={horizontalAlign} padding={{ top: ContainerPadding.dynamic0100 }}>
                {this.renderSmallImages(false)}
            </Container>
        )
    }


    /**
     *  Büyük görselin bulunduğu sayfanın yarısını kaplayan Container' ı
     *  render eden metod.
     */
    renderLeftContainer() {
        const dataList = sampleList(this.props);
        const currentImage = dataList[this.state.selectedImageIndex].image;

        return (
            <Container stretchContent={true} wrap={ContainerWrap.always}>
                <BreakpointWrapper min={Breakpoints.b560}>
                    <AspectRatioContainer ratio={AspectRatio['4:3']} >
                        <Image src={currentImage} alt={dataList[this.state.selectedImageIndex].title} />
                    </AspectRatioContainer>
                </BreakpointWrapper>
                <BreakpointWrapper min={Breakpoints.b560}>
                    {this.renderSmallImagesForDesktop()}
                </BreakpointWrapper>
            </Container>
        )
    }

    /**
     *  Accordionların bulunduğu sayfasının yarısını kaplayan Container' ı
     *  render eden metod.
     */
    renderRightContainer() {
        const selectedIndex = this.state.selectedIndex;
        const dataList = sampleList(this.props);
        const currentImage = dataList[this.state.selectedImageIndex].image;

        const renderedAccordions = dataList.map((data, index) => {

            if (data.title)
                return (
                    <CustomAccordion
                        horizontalPadding={rightContainerPadding} 
                        title={<Text appearance={TextAppearance.copy0200} bold>{data.title}</Text>}
                        isOpen={selectedIndex === index}
                        onClick={() => 
                            this.setState({ 
                                selectedIndex: selectedIndex === index ? null : index,
                                selectedImageIndex: index
                            })}
                        line
                        linePadding={rightContainerPadding}
                    >
                        <Container stretchContent={true} gutter={ContainerGutter.dynamic0100}>
                            <BreakpointWrapper max={Breakpoints.b560}>
                                <Image src={currentImage} />
                            </BreakpointWrapper>
                            <Container padding={{left: rightContainerPadding, right: rightContainerPadding}} >
                                <Text appearance={TextAppearance.copy0150}>{data.description} </Text>
                            </Container>
                        </Container>
                    </CustomAccordion>
                )
            return <div />;
    })

        const padding = { 
            top: rightContainerTopPadding
        }
            
        return (
            <Container 
                shrinkContent={true} 
                wrap={ContainerWrap.always}
                padding={padding}
            >
                {renderedAccordions}
            </Container>
        )
    }

    render() {
        const isMobile = typeof window !== `undefined` && window.innerWidth <= 768;
        if(isMobile){
            return (
                <IntegratorRoot>
                    <ThemeProvider>
                    <div style={{marginBottom: -125}}></div>
                        <Layout appearance={layoutBreakpoints}>
                            {this.renderLeftContainer()}
                            {this.renderRightContainer()}
                        </Layout>
                    </ThemeProvider>
                </IntegratorRoot>
            )
        }else {
  return (
            <IntegratorRoot>
                <ThemeProvider>
                    <Layout appearance={layoutBreakpoints}>
                        {this.renderLeftContainer()}
                        {this.renderRightContainer()}
                    </Layout>
                </ThemeProvider>
            </IntegratorRoot>
        )
        }
      
    }
}

const layoutBreakpoints = {
    [Breakpoints.default]: [
        { name: 'a', columns: 24 },
        { name: 'b', columns: 24 }
    ],
    [Breakpoints.b960]: [
        { name: 'a', columns: 14 },
        { name: 'b', columns: 10 }
    ]
}

const rightContainerPadding = {
    [Breakpoints.default]: ContainerPadding.grid002,
    [Breakpoints.b560]: ContainerPadding.grid006,
    [Breakpoints.b960]: ContainerPadding.grid001
}

const rightContainerTopPadding = {
    [Breakpoints.default]: ContainerPadding.dynamic0100,
}


export default AccordionContent;



const sampleList = (props) => [
    {
        title: props.custom,
        description: props.custom10,
        image: props.custom20
    },
    {
        title: props.custom1,
        description: props.custom11,
        image: props.custom21
    },
    {
        title: props.custom2,
        description: props.custom12,
        image: props.custom22
    },
    {
        title: props.custom3,
        description: props.custom13,
        image: props.custom23,
    },
    {
        title: props.custom4,
        description: props.custom14,
        image: props.custom24
    },
    {
        title: props.custom5,
        description: props.custom15,
        image: props.custom25
    },
    {
        title: props.custom6,
        description: props.custom16,
        image: props.custom26
    },
    {
        title: props.custom7,
        description: props.custom17,
        image: props.custom27
    },
    {
        title: props.custom8,
        description: props.custom18,
        image: props.custom28
    },
    {
        title: props.custom9,
        description: props.custom19,
        image: props.custom29
    },
]